<template>
	
	   <div class="mdc-card mgt-24 pdt-24 pdb-16 pdl-24 pdr-24" v-if="listData && essay">
					<div class="t-color4 t-color-bodyGrayA l-spacing36 font-r t-body3">{{ $t('1958')}}</div>
				<!-- <div class="t-subtitle5 t-color-headlineBlack font-r pdb-16">
					<vue-mathjax :formula="listData.question.contents"></vue-mathjax>
				</div>
				<div class="mgt-16" v-if="questionImage">
					<img :src="questionImage" alt="" v-if="questionImage" class="report-img-video-bd-radius" :class="questionImage? 'mgt-16':''">
				</div> -->
					<div class="mgt-8 mgb-16 font-m t-subtitle3">
						<vue-mathjax :formula="listData.question.contents" v-if="listData.question.useMathjax"></vue-mathjax>
						<div v-else>
							{{ listData.question.contents }}
						</div>
					</div>
					<div v-if="questionImage">
						<img class="round mgb-8" :src="questionImage" alt="" />
				</div>
				<div class="question-choices essay mgt-16">
		   <label
				class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full   mdc-text-field--disabled disabled--Updated"
				data-mdc-auto-init="MDCTextField"
				:id="`answerEl`"
					>
					<!-- <div class="mdc-text-field mdc-text-field--textarea mdc-text-field--fullwidth" :id="`answerEl`"> -->
						<textarea id="textarea" class="mdc-text-field__input"
							rows="5"
							v-model="textAnswer"
							readonly
							disabled
						></textarea>
						<div class="mdc-notched-outline">
							<div class="mdc-notched-outline__leading"></div>
							<div class="mdc-notched-outline__notch">
							
							</div>
							<div class="mdc-notched-outline__trailing"></div>
						</div>
					</label>

					<hr class="divider mtb-1">

					<div class="mdc-card mdc-elevation--z3 my-degree-card mgt-16 mgb-16">
						<div class="correct-rate d-flex pda-default justify-content-between align-items-baseline">
							<div class="t-body2" style="color: var(--HeadlineBlack) !important;">
								{{$t('1276')}}
								<!-- 채점 결과 -->
							</div>
							<div class="t-body3" style="color: var(--HeadlineBlack) !important;" >
								{{$t('1277')}}
								<!-- 정답률  -->
								<span class="t-headline9">
									{{essay.partialScore}} %
								</span>
							</div>
						</div>
					</div>

					<div v-if="essay.essentialWordList.length > 0">
						<div class="t-body2 mgb-8" style="color: var(--HeadlineBlack) !important;">
							{{$t('1278')}}
							<!-- 필수 포함되어야 할 단어 -->
						</div>
						<div class="t-body2 bg-quizGray b-radius4 pdr-24 mgb-8">
							<div class="t-body1 choice">
								<div class="choice-text">
									<div class="text essential-word pdt-6 pdb-6 pdl-16 pdr-16 t-color-quizBlack">
										<span v-for="(word, index) in essay.essentialWordList" :key="index">
											{{word}}{{essay.essentialWordList.length > index+1 ? ', ' : ''}}
										</span>
									</div>
								</div>
							</div>
							
						</div>

					</div>
					
				</div>

			</div>
</template>

<script>
/**
 * 단일답안 문항 피드백 컴포넌트(short answer type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */
import {MDCTextField} from '@material/textfield'
import {questionMixin} from '@/mixins/question.js'
export default {
	props: ['listData', 'essay'],
	data() {
		return {
			textAnswer: '',
			textCorrect: '',
			questionImage:null
		}
	},
	mixins: [questionMixin],
	mounted() {
		this.textAnswer = this.essay.textAnswer
		this.textCorrect = this.essay.textCorrect
		if(this.listData && this.listData.question && this.listData.question.image) {
			let getImage = this.listData.question.image.resourceUri.split('default_thumnail_en.jpg')
			if(getImage[1] !=''){
				this.questionImage = this.listData.question.image.resourceUri;
			} else {
				this.questionImage = null
			}
		}

		const textField = new MDCTextField(document.getElementById(`answerEl`))
	},
	components: {
	
	},

}
</script>
